var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"start page one",attrs:{"id":"start"}},[_c('h2',[_vm._v("Contact Jancarus")]),_vm._v(" "),_c('h3',{staticStyle:{"font-size":"1.2rem"}},[_vm._v(" Choose one category that best suits you.")]),_vm._v(" "),_c('div',{staticClass:"start-margin"},[_c('my-booking')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f0d7f64","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GetStarted.vue
// module id = null
// module chunks = 